import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductDetailsDescriptionService } from '../_services/product-details-description.service';
import { ProductDetailsDescription } from '../_models/ProductDetailsDescription';
import { CookieService } from 'ngx-cookie-service';
import { KeyValue } from '@angular/common';
import { MAT_CHECKBOX_CLICK_ACTION } from '@angular/material';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductImageComponent } from '../product-image/product-image.component';
import { AutoHeightService } from 'ngx-owl-carousel-o/lib/services/autoheight.service';
import { CategorySearchService } from '../_services/category-search.service';

@Component({
  selector: 'app-product-description',
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.css']
})
export class ProductDescriptionComponent implements OnInit {
  page = 0;
  size = 15;
  productId: any;
  updateFlag: string;
  productDetailsDescription: ProductDetailsDescription
  productImageUrl: string[];
  productName: String;
  categoryName: String;
  price: String;
  productDetails: Object;
  similarProducts: Object[];
  productDesc: String;
  similarProductsCount: Number;
  userid: String;
  imagesUrl: any = [];
  userId: number;
  isMoreImage: boolean;
  moreImageProduct: any;
  productAttributes = []
  colorways = []
  data = []
  productMainImage: any;
  imagesToDB: any;
  filesToUpload: any;
  productDescriptionDataFromDB: any;
  productSku: number;
  stockListRequest: any;
  stockDetails: any;
  availableStock: any;
  availableStockMeters: any;


  constructor(
    private activatedRoute: ActivatedRoute,
    private productDetailsDescriptionService: ProductDetailsDescriptionService,
    private router: Router,
    private cookieService: CookieService,
    private dialog: MatDialog,
    private categoryService: CategorySearchService,
  ) {

    this.activatedRoute.params.subscribe(params => {
      this.productId = params['id'];
      this.updateFlag = 'true';
    })
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {
    this.getProductDetailsByProductId(this.productId)
  }
  // clickMe() {
  //   window.open("productMainImage");
  // }


  getProductDetailsByProductId(productId) {

    this.userId = +this.cookieService.get('UserId')
    this.productDetailsDescriptionService.getProductDetailsByProductId(productId, this.userId).subscribe(resp => {
      this.productDetailsDescription = resp as ProductDetailsDescription
      console.log(JSON.stringify(this.productDetailsDescription))
      this.imagesUrl = this.productDetailsDescription.productImages
      this.imagesUrl.forEach(element => {
        if (element.imageType == "productMainImage") {
         this.productMainImage = element.path
         console.log("this.productMainImage",this.productMainImage)
        //this.productMainImage="http://54.187.185.32:8080//home-fabrics/productImages/LIAZ%20TAPE%204%20CANVAS%20IVORY%20FUSSIA.jpg"
        }

      });
      this.productAttributes = this.productDetailsDescription.productAttributes
      this.colorways = this.productDetailsDescription.colorWays;
      console.log(this.imagesUrl)
      console.log("this.colorways", this.colorways)
      var images = this.imagesUrl.filter(images => {
        return images.imageName = images.imageName.substring(0, images.imageName.indexOf("_"))


      })
      // console.log(images)
      this.productImageUrl = this.productDetailsDescription.productImages;
      this.categoryName = this.productDetailsDescription.categoryName;
      this.productName = this.productDetailsDescription.productName;
      this.productDetails = this.productDetailsDescription.productDetails;
      //this.price = this.productDetailsDescription.price;
      this.productSku = this.productDetailsDescription.productDetails.SKU;
      console.log("this product sku-",this.productSku)
      this.stockListRequest={
        "requestHeader": {
            "createdSystem": "HF-WEBSITE",
            "createdBy": "user id",
            "createdDate": "11/25/2021 08:25:00",
            "createdByUserName": "Sinkaram Lena"
        },
        "requestBody": {
            "skuNumberList": [this.productSku]
        }
    }
    this.categoryService.getStockDetails(this.stockListRequest).subscribe(data => {
      this.stockDetails = data
      console.log(this.stockDetails)
      if(this.stockDetails.responseBody.stockList.length!=0){
      this.availableStock=this.stockDetails.responseBody.stockList[0].availableStock
      this.availableStockMeters = this.availableStock * 0.9144;
      this.availableStockMeters = this.availableStockMeters.toFixed(2);
      console.log("this.availableStockMeters meters:",this.availableStockMeters)
      this.productAttributes.push({productAttributeName:'Available Stock',productAtrributeValue:this.availableStock+' yards / '+this.availableStockMeters+' meters'})
      }
      else{
        this.productAttributes.push({productAttributeName:'Available Stock',productAtrributeValue:'0'})
      }
    })
    console.log("productDetails----",this.productDetails)
      this.similarProducts = this.productDetailsDescription.similarProducts
      console.log("product description similar products: ",this.similarProducts)
      this.productDesc = this.productDetailsDescription.productDescription;
      this.similarProductsCount = this.productDetailsDescription.similarProductsCount
      this.getData({ pageIndex: this.page, pageSize: this.size });
    })
  }
  viewImage(): void {
    console.log(this.productMainImage)
    try {
      const dialogRef = this.dialog.open(ProductImageComponent, {
        width:'auto',
        height:'auto',
        data: {
          productData: this.productMainImage
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      })
    } catch (error) {
      console.error('Error in getParentCategory Request', error);
    }

  }

  moreImage(products) {
    console.log("moreimage: ", products.productId);
    this.getProductDetailsByProductId(products.productId)
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  getData(obj) {
    let index = 0,
      startingIndex = obj.pageIndex * obj.pageSize,
      endingIndex = startingIndex + obj.pageSize;
    if (this.colorways != null) {

      this.data = this.colorways.filter(() => {
        index++;
        return (index > startingIndex && index <= endingIndex) ? true : false;
      });
    }

  }

  originalOrder = (firstValue: KeyValue<number, string>, secondValue: KeyValue<number, string>): number => {
    return 0;
  }
}

// function onClick(element) {
//   document.getElementById("img01").src = element.src;
//   document.getElementById("modal01").style.display = "block";
// }
// function imageZoom() {
//   var img, lens, result, cx, cy;
//   img = document.getElementById(img);
//   result = document.getElementById(result);
//   /* Create lens: */
//   lens = document.createElement("DIV");
//   lens.setAttribute("class", "img-zoom-lens");
//   /* Insert lens: */
//   img.parentElement.insertBefore(lens, img);
//   /* Calculate the ratio between result DIV and lens: */
//   cx = result.offsetWidth / lens.offsetWidth;
//   cy = result.offsetHeight / lens.offsetHeight;
//   /* Set background properties for the result DIV */
//   result.style.backgroundImage = "url('" + img.src + "')";
//   result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
//   /* Execute a function when someone moves the cursor over the image, or the lens: */
//   lens.addEventListener("mousemove", moveLens);
//   img.addEventListener("mousemove", moveLens);
//   /* And also for touch screens: */
//   lens.addEventListener("touchmove", moveLens);
//   img.addEventListener("touchmove", moveLens);
//   function moveLens(e) {
//     var pos, x, y;
//     /* Prevent any other actions that may occur when moving over the image */
//     e.preventDefault();
//     /* Get the cursor's x and y positions: */
//     pos = getCursorPos(e);
//     /* Calculate the position of the lens: */
//     x = pos.x - (lens.offsetWidth / 2);
//     y = pos.y - (lens.offsetHeight / 2);
//     /* Prevent the lens from being positioned outside the image: */
//     if (x > img.width - lens.offsetWidth) { x = img.width - lens.offsetWidth; }
//     if (x < 0) { x = 0; }
//     if (y > img.height - lens.offsetHeight) { y = img.height - lens.offsetHeight; }
//     if (y < 0) { y = 0; }
//     /* Set the position of the lens: */
//     lens.style.left = x + "px";
//     lens.style.top = y + "px";
//     /* Display what the lens "sees": */
//     result.style.backgroundPosition = "-" + (x * cx) + "px -" + (y * cy) + "px";
//   }
//   function getCursorPos(e) {
//     var a, x = 0, y = 0;
//     e = e || window.event;
//     /* Get the x and y positions of the image: */
//     a = img.getBoundingClientRect();
//     /* Calculate the cursor's x and y coordinates, relative to the image: */
//     x = e.pageX - a.left;
//     y = e.pageY - a.top;
//     /* Consider any page scrolling: */
//     x = x - window.pageXOffset;
//     y = y - window.pageYOffset;
//     return { x: x, y: y };
//   }
//   // imageZoom("img", "result");



// }



